import { useState } from "react";
import ErrorBoundary from "../components/ErrorBoundary.jsx";
import { downloadFinalUpdated } from "../api.js";

export default function Export() {
  const [downloading, setDownloading] = useState(false);
  const [msg, setMsg] = useState("");

  async function onDownload() {
    setDownloading(true);
    setMsg("");
    try {
      const blob = await downloadFinalUpdated();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Final Updated Info Int-Locals-Foreigns clients 2025.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setMsg("Export generated.");
    } catch (e) {
      setMsg(e.message || "Export failed");
    } finally {
      setDownloading(false);
    }
  }

  return (
    <ErrorBoundary componentName="ExportPage">
      <div className="container">
        <h1 className="page-title">Export Final Updated Info</h1>
        <div className="card">
          <p>Download the Final Updated Info workbook with the latest company data.</p>
          <div className="toolbar">
            <button onClick={onDownload} disabled={downloading}>
              {downloading ? "Generating…" : "Download"}
            </button>
          </div>
          {msg && <div className="note">{msg}</div>}
        </div>
      </div>
    </ErrorBoundary>
  );
}
